import type {
  GroupedPageParamsQueryData,
  GroupedWithSecondaryGroupsPageParamsQueryData,
  MemexGroupsPageQueryData,
  MemexItemsPageQueryData,
  MemexPageQueryData,
  PageParamsQueryData,
} from './types'

/**
 * Returns true if queryData is defined and is a page of items.
 * Could be a page of flat items or a page of items within a specific group.
 */
export function isQueryPageOfItems(queryData: MemexPageQueryData | undefined): queryData is MemexItemsPageQueryData {
  return queryData !== undefined && 'nodes' in queryData
}

export function isQueryDataGrouped(queryData: MemexPageQueryData): queryData is MemexGroupsPageQueryData {
  return 'groups' in queryData
}

export function isPageParamsDataGrouped(
  pageParamsData: PageParamsQueryData,
): pageParamsData is GroupedPageParamsQueryData {
  return 'groupedItems' in pageParamsData
}

export function isPageParamsDataGroupedWithSecondaryGroups(
  pageParamsData: PageParamsQueryData,
): pageParamsData is GroupedWithSecondaryGroupsPageParamsQueryData {
  return 'secondaryGroups' in pageParamsData
}
